;(function() {
  'use strict'

  Factory.$inject = ["$q", "glToast", "surveyServiceNext"];
  angular.module('app.core').factory('quotaSaveService', Factory)

  /* @ngInject */
  function Factory($q, glToast, surveyServiceNext) {
    return {
      save: save,
    }

    function save(survey) {
      return surveyServiceNext
        .save(survey)
        .then(function(result) {
          glToast.show('Quotas saved.')
          return result
        })
        .catch(function(err) {
          console.error(err)
          glToast.show('Quotas could not be saved. Please try again.')
          return $q.reject(err)
        })
    }
  }
})()
